import { User, MoreVertical, Edit, Trash2, Plus } from 'lucide-react';
import { FamilyMember } from '@/types';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

interface TreeNodeProps {
  member: FamilyMember;
  onEdit?: (member: FamilyMember) => void;
  onDelete?: (member: FamilyMember) => void;
  onAddChild?: (member: FamilyMember) => void;
  isAdmin: boolean;
}

export function TreeNode({ member, onEdit, onDelete, onAddChild, isAdmin }: TreeNodeProps) {
  const handleAction = (e: React.MouseEvent, action: () => void) => {
    e.stopPropagation();
    action();
  };

  return (
    <div className="h-full relative">
      <div
        className={`h-full bg-white rounded-lg shadow-sm border-2 border-primary/20 p-4 flex flex-col items-center justify-center gap-2 transition-all duration-200 ${
          isAdmin ? 'hover:border-secondary hover:shadow-md group' : ''
        }`}
      >
        {isAdmin && (
          <>
            <Button
              variant="ghost"
              size="icon"
              className="absolute top-2 right-2 h-8 w-8 rounded-full opacity-0 group-hover:opacity-100 hover:bg-primary hover:text-white transition-all"
              onClick={(e) => handleAction(e, () => onAddChild?.(member))}
            >
              <Plus className="h-4 w-4" />
            </Button>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button 
                  variant="ghost" 
                  size="icon"
                  className="absolute top-2 left-2 h-8 w-8 opacity-0 group-hover:opacity-100 hover:bg-primary hover:text-white transition-all"
                >
                  <MoreVertical className="h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent 
                align="end" 
                className="w-32 bg-white border rounded-lg shadow-lg"
              >
                <DropdownMenuItem 
                  onClick={(e) => handleAction(e, () => onEdit?.(member))}
                  className="hover:bg-primary hover:text-white cursor-pointer"
                >
                  <Edit className="h-4 w-4 ml-2" />
                  تعديل
                </DropdownMenuItem>
                <DropdownMenuItem 
                  onClick={(e) => handleAction(e, () => onDelete?.(member))}
                  className="text-red-600 hover:bg-red-600 hover:text-white cursor-pointer"
                >
                  <Trash2 className="h-4 w-4 ml-2" />
                  حذف
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </>
        )}

        <div className="flex flex-col items-center">
          {member.info?.photoUrl ? (
            <img
              src={member.info.photoUrl}
              alt={member.name}
              className="w-12 h-12 rounded-full object-cover border-2 border-primary"
            />
          ) : (
            <span className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <User className="w-6 w-6 text-primary" />
            </span>
          )}
          <h3 className="text-sm font-medium text-primary-dark text-center mt-2">
            {member.name}
          </h3>
        </div>
      </div>
    </div>
  );
}